import React, { useState } from "react";
import Data from "../recipeData";
import Card from "./card";
import Buttons from "./buttons";

const Video = () => {
  const [item, setItem] = useState(Data);
  const menuItems = [...new Set(Data.map((Val) => Val.category))];

  const filterItem = (curcat) => {
    const newItem = Data.filter((newVal) => {
      return newVal.category === curcat;
    });
    setItem(newItem);
  };

  return (
    <>
      <div className="youtube-videos">
          <Buttons
            filterItem={filterItem}
            setItem={setItem}
            menuItems={menuItems}
          />
          <Card item={item} />
      </div>
    </>
  );
};

export default Video;